interface ClosingCTAProps {
  eyebrow?: string;
  headline?: React.ReactNode;
  subhead?: string;
  body?: string;
  ctaLabel?: string;
}

export function ClosingCTA({
  eyebrow = "Let’s Talk",
  headline = (
    <>
      Stop Asking Prospects to <span className="text-primary">“Contact Us.”</span>
    </>
  ),
  subhead = "Give them a reason to.",
  body = "Whether you have an idea for a calculator, assessment or custom app, or simply know there’s something useful you could build for your audience, let’s explore what’s possible.",
  ctaLabel = "Let’s Build Something Useful",
}: ClosingCTAProps = {}) {
  return (
    <section id="contact" className="px-6 md:px-8 lg:px-12 py-16 md:py-20 border-t border-border/50 bg-[#080E1E]/95 text-white">
      <div className="max-w-4xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl border border-border/50 bg-card/30 px-8 py-14 md:px-14 md:py-16 text-center">
          <span
            className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-primary via-sky-300 to-transparent"
            aria-hidden="true"
          />
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-primary mb-5">
            {eyebrow}
          </p>
          <h2 className="text-3xl sm:text-4xl font-semibold leading-tight">{headline}</h2>
          <p className="mt-5 text-lg font-medium text-foreground">{subhead}</p>
          <p className="mt-4 max-w-xl mx-auto text-muted-foreground leading-relaxed">{body}</p>
          <a
            href="https://calendly.com/cgould-mn/new-meeting"
            target="_blank"
            rel="noreferrer"
            className="inline-flex mt-9 items-center gap-2 rounded-full border border-white/30 px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
          >
            {ctaLabel}
          </a>
        </div>
      </div>
    </section>
  );
}
